import { useAppSelector } from 'store/hooks';
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { SIGN_IN } from 'config/routes';
import { ApplicationState } from 'store/store';
import { Throbber } from 'ui/Throbber';

export const PrivateRoute: React.FC = () => {
    const auth = useAppSelector(
        (state: ApplicationState) => state.auth,
        (left, right) => left.authorizedDate?.toString() === right.authorizedDate?.toString()
    );
    if (auth.isAuthorizingInProgress) {
        return <Throbber />;
    }
    if (!auth.claims) {
        return <Navigate to={SIGN_IN} replace />;
    }
    return <Outlet />;
};
